import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse
} from '@angular/common/http';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { map, catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '../../../../environments/environment';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
  ) { }

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (httpRequest.headers.get('No-Authorization')) {
      return next.handle(httpRequest);
    }

    return this.auth.isLoading$.pipe(
      filter((isLoading) => !isLoading),
      take(1),
      switchMap(() => this.getAccessTokenSilently()),
      map((token) => httpRequest.clone({ setHeaders: { Authorization: `Bearer ${token}` } })),
      switchMap((modified) => next.handle(modified)),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 || err.message === "Login required") {
          this.loginWithRedirect();
          return EMPTY;
        }
        return throwError(err);
      })
    );
  }


  private loginWithRedirect() {
    const randomStateValue = window.location.href.replace(window.location.origin, '');
    localStorage.setItem('randomStateValue', randomStateValue);

    this.auth.loginWithRedirect({
      appState: { returnTo: randomStateValue },
    });
  }

  private getAccessTokenSilently(): Observable<string> {
    if (!environment.allowE2eAuth) {
      return this.auth.getAccessTokenSilently();
    }

    if (localStorage.getItem('e2e') === 'playwright') {
      const playwrightAuth0Token = localStorage.getItem('playwrightAuth0Token');
      if (playwrightAuth0Token) {
        return of(JSON.parse(playwrightAuth0Token));
      }
    }

    return this.auth.getAccessTokenSilently();
  }
}
